import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initStickySidebar() {
  // カレントナビ作成
  createSectionNav();

  // サイドバー固定
  pinSidebar();
}

/**
 * sectionのidを自動取得してセクションナビを動的生成（[id^=sec-]のものに限る）
 */
function createSectionNav() {
  const nav = document.getElementById("js-section-tracker-nav");
  const sectionList = document.querySelectorAll("[id^=sec-]");
  if (!nav) return;

  // ナビゲーションのHTML文字列を格納して生成する
  let htmlTxt = "";
  htmlTxt += '<ul class="p-section-tracker-nav__list">';

  // sectionごとに処理をし、見出しを元にナビゲーションのHTMLを作成する
  sectionList.forEach((section) => {
    const h2 = section.querySelector("h2");
    if (!h2) return;

    // 自動で見出しのidを作成
    const h2Id = `nav-${section.id}`;
    h2.id = h2Id;

    htmlTxt += `<li class="p-section-tracker-nav__item" data-tracker="${section.id}">
                  <a class="p-section-tracker-nav__link" href="#${h2Id}">${h2.textContent}</a>`;
    htmlTxt += "</li>";
  });
  htmlTxt += "</ul>";

  // 完成したHTMLで置き換え
  nav.innerHTML = htmlTxt;

  // ScrollTriggerによるカレントの付け替え処理を登録
  sectionList.forEach((section) => {
    ScrollTrigger.create({
      trigger: section,
      start: "top 25%",
      end: "bottom 25%",
      toggleClass: {
        targets: `[data-tracker="${section.id}"]`,
        className: "is-current",
      },
    });
  });
}

/**
 * サイドバーをsticky表示
 */
function pinSidebar() {
  const sidebar = document.querySelector(".js-sticky-sidebar-content");
  if (!sidebar) return;

  // メディアクエリを作成
  let mm = gsap.matchMedia();

  mm.add("not all and (max-width: 1024px)", () => {
    // ヘッダーガターを取得（追従時に被らないように）
    let headerGutter = getComputedStyle(document.documentElement)
      .getPropertyValue("--header-height-gutter")
      .replace("px", "");
    headerGutter = parseInt(headerGutter, 10);

    gsap.to(".js-sticky-sidebar-content", {
      scrollTrigger: {
        trigger: ".js-sticky-sidebar-content",
        start: "top-=180 top",
        end: () => {
          // サイドバーの高さとメインコンテンツの高さを比較し、終了位置を動的に計算
          const sidebarHeight = document.querySelector(
            ".js-sticky-sidebar-content",
          ).offsetHeight;
          const mainHeight = document.querySelector(
            ".js-has-sticky-sidebar",
          ).offsetHeight;
          return `+=${mainHeight - sidebarHeight}`;
        },
        endTrigger: ".js-has-sticky-sidebar",
        pin: true,
        invalidateOnRefresh: true,
        // markers: true
      },
    });
  });
}
